export default {
  en: {
    a11yText: 'Reveal additional information.'
  },
  fr: {
    a11yText: 'Afficher des renseignements supplémentaires.'
  }
};